/* eslint-disable max-len */
import { dataService } from "../services/data.services";
import { CognitoCurrentData, CognitoData } from "./CognitoData";

const generateKeyPair=(arr)=>{
    let myData=[];
    arr.map((val)=>{
        myData.push({
            name:val.branch_name || val.name,
            id:val._id||val.id,
            status:val.status
        })
    })
    return myData
}
export const FetchBranch=async()=>{
    const branchlist = await CognitoData()
    let branch=[]
    let res;
    let list=[]
    const type=branchlist.idToken.payload['custom:user_type']
    if(type==='institution-admin'){
        res = await dataService.GetAPI(`branch?&institution_id=${branchlist.idToken.payload['custom:institution_id']}&sort=status%2Basc`);
        list=res.data.data.data

    }else if(type==='institution-user'){
        res = await dataService.GetAPI(`users/${branchlist.idToken.payload['email']}`);
        list=res.data.data.data.branches


    }else{
        res = await dataService.GetAPI(`users/${branchlist.idToken.payload['email']}`);
        list=res.data.data
        list['_id']=res.data.data.branch_id
    }
    if(list.length>0 &&(type==='institution-admin' || type==='institution-user') || Object.keys(list).includes('_id')){
        const arr=type==='institution-admin' || type==='institution-user'?list:[list];
        branch=(generateKeyPair(arr));
              
                
    }
    return branch;

}